import { ErrorMessage, Field } from "formik";
import React from "react";
import { Label } from "../InputField/inputFieldStyle";
import Message from "../Message/Message";
import { TextAreaStyled } from "./TextAreaStyle";

export const TextArea = ({ placeholder, className, name, id, label, type }) => {
  return (
    <>
      <Label htmlFor={name}>{label}</Label>
      <Field
        id={name}
        type={type}
        name={name}
        placeholder={placeholder}
        className={className}
      />
      <ErrorMessage
        name={id}
        render={(msg) => (
          <Message size="12px" color="red" weight="bold">
            {msg}
          </Message>
        )}
      />
    </>
  );
};
